import ALG_EXT_1 from "./ALG_EXT_1";
export default {
  ALG_EXT_1,
};
